module.exports = __webpack_public_path__ + "img/11088017_L.66e16e4a.png";